import SidePanel from '@monofront/design-system/organisms/SidePanel';
import ArrowLeft from '@monofront/design-system/visuals/Icons/ArrowLeft';
import { useTranslations } from 'next-intl';

type DefaultHeaderProps = {
  onClose: () => void;
  onGoBack?: () => void;
  title?: string;
  showGoBackButton?: boolean;
};
export const DefaultPanelHeader: React.FC<DefaultHeaderProps> = ({
  onClose,
  onGoBack,
  showGoBackButton = true,
  title = '',
}) => {
  const tGlobal = useTranslations('Global');
  const tAddressForm = useTranslations('DeliveryBar.AddressForm');

  const handleGoBack = () => {
    onGoBack?.();
  };

  return (
    <SidePanel.SidePanelHeader onClose={onClose}>
      <div className="tw-flex tw-items-center">
        {showGoBackButton && (
          <button
            aria-label={tGlobal('back')}
            className="tw-lf-button-clear tw-mr-1"
            onClick={handleGoBack}
            data-testid="Deliverybar-go-back-button"
          >
            <ArrowLeft aria-hidden />
          </button>
        )}
        <h2 className="tw-lf-title-sm">
          {title ? title : tAddressForm('headerTitle')}
        </h2>
      </div>
    </SidePanel.SidePanelHeader>
  );
};
